import { useSelector, useDispatch } from 'react-redux';

import { STEPS } from './constants';
import { Actions } from '~/store/registration/actions';
import { STATUS } from '~/store/registration/constants';
import { getStatus } from '~/store/registration/selectors';

export const useVerificationStatus = (): keyof typeof STEPS => {
  const status = useSelector(getStatus);

  const statusToStep = {
    [STATUS.VERIFYING_EMAIL]: STEPS.VERIFY,
    [STATUS.VALID_TOKEN]: STEPS.REDIRECT_TO_LOGIN,
    [STATUS.INVALID_TOKEN]: STEPS.REDIRECT_TO_LOGIN,
    [STATUS.EXPIRED_TOKEN]: STEPS.LINK_RESENT,
  };

  return (statusToStep[status] || STEPS.LINK_RESENT) as keyof typeof STEPS;
};

export const useVerifyResetToken = (): ((resetToken: string) => void) => {
  const dispatch = useDispatch();
  return (resetToken: string): void => {
    dispatch(Actions.CONFIRM_EMAIL_REQUEST({ resetToken }));
  };
};
